// String
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Lang
import { nsSimCard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.selectedOffer
 * @returns {JSX} Confirmation
 */
function Confirmation({ selectedOffer }) {
    return (
        <div className='text-center my-4 space-y-2'>
            <div>
                <Entity
                    entity='modal.multiple_activation.confirmation.text_1'
                    data={{ offer: selectedOffer }}
                    namespace={nsSimCard}
                />
            </div>
            <div>
                <Entity
                    entity='modal.multiple_activation.confirmation.text_2'
                    namespace={nsSimCard}
                />
            </div>
            <div>
                <Entity
                    entity='modal.multiple_activation.confirmation.text_3'
                    namespace={nsSimCard}
                />
            </div>
        </div>
    );
}

Confirmation.propTypes = {
    selectedOffer: PropTypes.string
};
export default Confirmation;